import { Navigate } from 'react-router-dom';
import { useUserStore } from '../store/userStore';

export default function RequireAdmin({ children }: { children: React.ReactNode }) {
  const isAdmin = useUserStore((s) => s.isAdmin);
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
